export default __webpack_public_path__ + "static/media/videocam(white).f0bc8a5b.svg";